'use strict';


const $ = require('jquery');
const AjaxInjector = function () {

    const insert = function (response, element, template) {
        const result = template(response);

        $(element).html(result);
    };

    const request = function (url, methode, data, element = false, template = false, loader = 'on') {
        return new Promise(function (resolve, reject) {

            const Ajax = require('./ajax.js');
            const Data = function (methode, data) {
                if (methode !== 'GET') {
                    let helper = {};
                    //const helper = window.oData;
                    helper.csrf_baptist = window.oData.csrf_baptist;
                    for (let key in data) {
                        helper[key] = data[key];
                    }
                    return helper;
                } else {
                    return '';
                }
            };

            if (loader === 'off') {
                const $loader = $('<div>').addClass('loader');
                $(element).append($loader);
            }

            return Ajax.send({
                    sUrl:  url,
                    sMethod: methode,
                    aData: Data(methode, data)
                })
                .then(function (oResponse) {

                    if (element && template) {
                        insert(oResponse, element, template);
                    }
                    resolve(oResponse);
                })
                .catch(function (err) {
                    reject(err);
                });
        });
    };

    return {
        request: request,
        insert: insert
    };
};

module.exports = new AjaxInjector();
